var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_4466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9082 9.28974L23.6247 10.0265L24.3416 9.28999C25.0202 8.59278 26.3457 8.80281 26.8312 9.75094C27.0409 10.1603 27.1272 10.8132 26.6588 11.7372C26.223 12.5968 25.311 13.6686 23.6251 14.8656C21.9396 13.6686 21.0278 12.5968 20.592 11.7371C20.1236 10.8128 20.2099 10.1596 20.4195 9.75013C20.9049 8.80196 22.2296 8.59205 22.9082 9.28974ZM14.75 8.75C14.75 9.87717 14.3022 10.9582 13.5052 11.7552C12.7082 12.5522 11.6272 13 10.5 13C9.37283 13 8.29183 12.5522 7.4948 11.7552C6.69777 10.9582 6.25 9.87717 6.25 8.75C6.25 7.62283 6.69777 6.54183 7.4948 5.7448C8.29183 4.94777 9.37283 4.5 10.5 4.5C11.6272 4.5 12.7082 4.94777 13.5052 5.7448C14.3022 6.54183 14.75 7.62283 14.75 8.75ZM1.76057 23.5C1.75763 23.4999 1.75272 23.4996 1.74605 23.4991C1.72479 23.4976 1.68788 23.4941 1.64096 23.4863C1.54239 23.4698 1.42625 23.4388 1.32221 23.3868C1.22209 23.3368 1.15239 23.2774 1.10549 23.207C1.06276 23.1429 1 23.0125 1 22.75C1 22.1318 1.33804 20.6387 2.67586 19.3009C3.98436 17.9923 6.33589 16.75 10.5 16.75C14.6641 16.75 17.0156 17.9923 18.3241 19.3009C19.662 20.6387 20 22.1318 20 22.75C20 23.0125 19.9372 23.1429 19.8945 23.207C19.8476 23.2774 19.7779 23.3368 19.6778 23.3868C19.5738 23.4388 19.4576 23.4698 19.359 23.4863C19.3121 23.4941 19.2752 23.4976 19.2539 23.4991C19.2473 23.4996 19.2424 23.4999 19.2394 23.5H1.76057Z",
    fill: "#FF7978",
    stroke: "#FF7978",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_4466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfCare);
export default __webpack_public_path__ + "static/media/selfCare.ffb34ae4c2832725428d12ff5322dd42.svg";
export { ForwardRef as ReactComponent };